import Profile from '../../features/profile/layouts/profile';

// TSS vite/01 §"Pages are thin" — the page mounts the feature, nothing else.

export default function ProfilePage() {
    return <Profile />;
}
